$(document).foundation();

jQuery(document).ready(function($) {
  mainHandler.init();
  productHandler.init();
  pdfHandler.init();
  rugHandler.init();
  if ($('.single.single-portfolio').length > 0) {
    portfolioHandler.init();
  }
  if ($('.page-my-account').length > 0) {
    myaccountHandler.init();
  }
  if ($('.woocommerce-page.page-cart').length > 0) {
    cartHandler.init();
  }

  if ($('.woocommerce-page.page-checkout').length > 0) {
    $.scroll_to_notices = function( scrollElement ) {
      if ( scrollElement.length ) {
          mainHandler.scrollto(0, 'slow');
      }
    };
  }

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
